import { getUserType } from "util/auth";
import { ROUTE_PERMISSION } from "util/route_permission";
import { USER_TYPE } from "./user-type";

/**
 *
 * @param path Path of the page
 */
const checkPermission = (path: string) => {
  const userType = getUserType() as keyof typeof USER_TYPE;
  if (!userType) {
    return false;
  }
  if (!path) {
    return true;
  }
  if (!ROUTE_PERMISSION[path]) {
    return true;
  }
  return ROUTE_PERMISSION[path].includes(userType);
};

export default checkPermission;
